
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.5","height":"14.824"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M1664.941 1966.376h-3.531v-4.466a.473.473 0 00-.442-.5h-3.531a.473.473 0 00-.442.5v4.466h-3.534v-8.15l5.74-4.571 5.74 4.571zm1.825-7.914l-7.311-5.821a.4.4 0 00-.511 0l-7.307 5.821a.536.536 0 00-.105.692.411.411 0 00.616.118l.431-.342v7.946a.473.473 0 00.442.5h4.414a.474.474 0 00.442-.5v-4.47h2.647v4.466a.474.474 0 00.442.5h4.414a.474.474 0 00.442-.5v-7.946l.431.342a.406.406 0 00.253.089.436.436 0 00.362-.208.531.531 0 00-.102-.686z","transform":"translate(-1651.45 -1952.55)","fill":"#fff","clip-rule":"evenodd"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('rect',{attrs:{"width":"16.938","height":"16.443","transform":"translate(-.719 -.81)","fill":"#fff"}})])])
          )
        }
      }
    